module.exports = __webpack_public_path__ + "img/bottom.5fa1ec70.png";